import React, {useContext, useEffect, useState} from 'react';
import GettingStartedContext from "../utils/GettingStartedContext";


const Dropdown = (props) => {

  const {
    type,
    link,
    paramId,
    lang,
    result,
    defaultOption,
    defaultTitle,
    showResult,

  } = props;

  const {
    data,
    ownership,
    plane,
    reloadResults,
    plan,
    setData,
    setOwnership,
    setPlane,
    getLink,
    setPlan,
    setHours,
    setReloadResults,
    staticBlock
  } = useContext(GettingStartedContext)

  const [value, setValue] = useState(defaultOption ? defaultOption : '');
  const [options, setOptions] = useState([]);
  const [dirty, setDirty] = useState(false);

  useEffect(()=>{
    if(staticBlock){
      fetch(
        getLink('getFilters'),
        {
          method: 'POST',
          body: JSON.stringify({
            data: {
              type: 'Planes',
              id: plane
            }
          })
        }
      )
        .then((response) => response.json())
        .then((res) => {
          const formOptions = {
            ...data.Options,
            ...res
          }

          const newData = {
            ...data,
            Options: formOptions
          };

          if (type !== 'Ownerships') {
            const match = res.Ownerships.find((o) => o.ID === ownership)
            if (!match) {
              setOwnership(res.Ownerships[0].ID);
            }
          }
          if (type !== 'Planes') {
            const match = res.Planes.find((o) => o.ID === plane)
            if (!match) {
              setOwnership(res.Planes[0].ID);
            }
          }
          setData(newData);
          
          if (showResult) {
            showResult(true);
          }
        });
    }
  },[])

  useEffect(() => {
    if(staticBlock){
        fetch(
          getLink('getFilters'),
          {
            method: 'POST',
            body: JSON.stringify({
              data: {
                type: 'Planes',
                id: plane
              }
            })
          }
        )
        .then((response) => response.json())
        .then((res) => {
        const formOptions = {
            ...data.Options,
            ...res
        }

        const newData = {
            ...data,
            Options: formOptions
        };

        if (type !== 'Ownerships') {
            const match = res.Ownerships.find((o) => o.ID === ownership)
            if (!match) {
            setOwnership(res.Ownerships[0].ID);
            }
        }
        if (type !== 'Planes') {
            const match = res.Planes.find((o) => o.ID === plane)
            if (!match) {
            setOwnership(res.Planes[0].ID);
            }
        }
        setData(newData);
        if (showResult) {
            showResult(true);
        }
        });
    }
    if (value) {
      getRelatedFilters();
    }
  }, [value]);


  useEffect(() => {
    if (typeof data.Options[type] !== 'undefined') {
      setOptions(data.Options[type]);
    }
    if (dirty) {
      setDirty(false);
      setReloadResults(!reloadResults);
    }
  }, [data])


  const getRelatedFilters = () => {
    fetch(
      getLink('getFilters'),
      {
        method: 'POST',
        body: JSON.stringify({
          data: {
            type: type,
            id: value
          }
        })
      }
    )
      .then((response) => response.json())
      .then((res) => {

        const formOptions = {
          ...data.Options,
          ...res
        }

        const newData = {
          ...data,
          Options: formOptions
        };

        if (type !== 'Ownerships') {
          const match = res.Ownerships.find((o) => o.ID === ownership)
          if (!match) {
            setOwnership(res.Ownerships[0].ID);
          }
        }
        if (type !== 'Planes') {
          const match = res.Planes.find((o) => o.ID === plane)
          if (!match) {
            setOwnership(res.Planes[0].ID);
          }
        }
        setData(newData);

        if (showResult) {
          showResult(true);
        }
      });
  }



  const handleChange = (event) => {
    const v = parseInt(event.target.value);
    setValue(v);
    setDirty(true);
    if (type === 'Planes') {
      setPlane(v);
    } else if (type === 'Plans') {
      setHours(v);
      const p = data.Options.Plans.find((op) => op.ID === v);
      setPlan(p);
    } else {
      setOwnership(v);
    }
  }

  return <select name={type.toLowerCase()}
      value={ value }
      onChange={handleChange}>
      <option value={ 0 } style={{color: 'grey'}}>{ defaultTitle }</option>
      {options.map((option) => {
        return <option
          key={option.ID}
          value={option.ID}>
          { option.Title }
        </option>
      })}
    </select>
}

export default Dropdown;
